import { render, staticRenderFns } from "./moment.vue?vue&type=template&id=2f28b170&lang=pug"
import script from "./moment.vue?vue&type=script&lang=js"
export * from "./moment.vue?vue&type=script&lang=js"
import style0 from "./moment.vue?vue&type=style&index=0&id=2f28b170&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports